import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {SearchSelectOption} from '../../../../../../_metronic/helpers/components/SearchSelect'
import {InvoiceRowForm} from '../core/_models'
import {InvoiceNetPrice} from '../invoice-edit-modal/steps/InvoiceNetPrice'
import {CustomInputs} from '../../../../../../_metronic/helpers/components/CustomInputs'
import {InvoiceSimpleFormItemTable} from './InvoiceSimpleFormItemTable'
import {FieldHelpLabel} from '../../../../../../_metronic/helpers/components/FieldHelp'
import {isTemplate11} from '../core/invoiceTemplate11'

type props = {
  getSumNetPrice: () => number
  invoiceType: number
  no: string
  date: string
  buyerSelected: SearchSelectOption | undefined
  items: InvoiceRowForm[]
  description: {
    description: string
    setDescription: Dispatch<SetStateAction<string>>
  }
  settlement: {
    settlement: string
    setSettlement: Dispatch<SetStateAction<string>>
  }
  invoiceTemplate?: number
}

const InvoiceSimpleFormSummary: FC<props> = ({
  getSumNetPrice,
  no,
  date,
  buyerSelected,
  items,
  description,
  invoiceType,
  settlement,
  invoiceTemplate,
}) => {
  const [settlementItems, setSettlementItems] = useState<SearchSelectOption[]>([])
  useEffect(() => {
    const settlementItems_: SearchSelectOption[] =
      invoiceType == 2
        ? [
            {
              label: 'نقدی',
              value: '1',
            },
          ]
        : [
            {
              label: 'نقدی',
              value: '1',
            },
            {
              label: 'نسیه',
              value: '2',
            },
            {
              label: 'نقدی/نسیه',
              value: '3',
            },
          ]

    // الگوی ۱۱: سهم نقدی روش نقد و نسیه فقط در فرم کامل صورتحساب گرفته می‌شود
    setSettlementItems(
      isTemplate11(invoiceType, invoiceTemplate)
        ? settlementItems_.filter((item) => item.value != '3')
        : settlementItems_
    )
  }, [invoiceType, invoiceTemplate])
  return (
    <>
      <div className='row'>
        <div className='col-12 mt-5 fs-3'>
          <span className='fs-5 text-gray-600 me-3'>
            <FieldHelpLabel label='سریال داخلی صورتحساب' helpKey='header.inno' />:
          </span>
          {no}
        </div>
        <div className='col-12 mt-5 fs-3'>
          <span className='fs-5 text-gray-600 me-3'>
            <FieldHelpLabel label='تاریخ و زمان صدور صورتحساب' helpKey='header.indatim' />:
          </span>
          {date}
        </div>
        {buyerSelected && (
          <div className='col-12 mt-5 fs-3'>
            <span className='fs-5 text-gray-600 me-3'>
              <FieldHelpLabel label='خریدار' helpKey='header.tinb' />:{' '}
            </span>
            {buyerSelected.label}
          </div>
        )}
        {!buyerSelected && (
          <div className='col-12 mt-5 fs-3'>
            {invoiceType == 2 ? (
              <>بدون خریدار</>
            ) : (
              <span className='text-danger'>خریدار را انتخاب کنید</span>
            )}
          </div>
        )}
        <div className='col-12 mt-5 fs-3'>
          <span className='fs-5 text-gray-600 me-3'>
            <FieldHelpLabel label='تعداد اقلام صورتحساب' helpKey='section.body' />:
          </span>
          {items.length}
        </div>
        <div className='col-12 mt-5'>
          <CustomInputs
            type='select'
            items={settlementItems}
            isRequired
            label={'نحوه تسویه'}
            stateValue={{
              value: settlement.settlement,
              setValue: settlement.setSettlement,
            }}
          />
        </div>
        <div className='col-12 mt-7'>
          <InvoiceSimpleFormItemTable items={items} />
        </div>
        <div className='col-12 mt-7'>
          <CustomInputs
            type='textarea'
            label={'سایر توضیحات صورتحساب'}
            hint={
              <>
                <span className='text-gray-600 fs-7'>
                  <i className='las la-info text-info fs-5'></i>
                  فقط جهت نمایش در انتهای صورتحساب چاپی
                </span>
              </>
            }
            stateValue={{
              value: description.description,
              setValue: description.setDescription,
            }}
          />
        </div>
      </div>
      <div className='mt-10'>
        <InvoiceNetPrice getSumNetPrice={getSumNetPrice} />
      </div>
    </>
  )
}

export {InvoiceSimpleFormSummary}
